import { useCallback, useEffect, useMemo, useState } from 'react'
import swal from 'sweetalert'
import { useNavigate, useParams } from 'react-router-dom'
import { CatchError } from 'Exceptions/exceptions'
import { getRefreshToken } from 'variables/common'
import BasicInput from 'views/components/Input/BasicInput'
import UserService from 'Main/service/UserService'
import { typeToNumber } from 'Main/Utils'

function UserProfile () {
  const { id } = useParams()
  const navigate = useNavigate()
  const refreshToken = getRefreshToken()
  const userService = useMemo(() => new UserService(), [])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)

  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [type, setType] = useState('')
  const [activation, setActivation] = useState('')
  const [creation, setCreation] = useState('')
  const [modified, setModified] = useState('')
  const [userId, setUserId] = useState(id || '')

  const fetchUser = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const res = await userService.getUser(id)
      const userData = res.data

      setUserId(userData.id || id || '')
      setUsername(userData.name || '')
      setEmail(userData.email || '')
      setType(userData.type || '')
      setActivation(userData.date || '')
      setCreation(userData.createdAt || '')
      setModified(userData.updatedAt || '')
    } catch (err) {
      const caught = CatchError(err, navigate, refreshToken)
      if (caught !== undefined) setError('Failed to load user profile.')
    } finally {
      setLoading(false)
    }
  }, [id, navigate, refreshToken, userService])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  const handleUpdate = () => {
    if (!password) {
      swal('Error', 'Password is required', 'error')
      return
    }

    swal('Update Users', 'Are You Sure to Update User?', 'question', {
      buttons: { cancel: 'Cancel', confirm: { text: 'Update', closeModal: false } }
    }).then(async (confirmed) => {
      if (!confirmed) return

      try {
        setSaving(true)
        await userService.updateUser(userId, {
          username,
          email,
          password,
          type: typeToNumber(type)
        })
        swal.close()
        await swal('Success!', 'User updated', 'success')
        navigate('/dashboard/profile')
      } catch (err) {
        const caught = CatchError(err, navigate, refreshToken)
        if (caught !== undefined) swal('Error', 'Failed to update user', 'error')
      } finally {
        setSaving(false)
      }
    })
  }

  return (
    <>
      <div className="page-heading">
        <h3>User Profile</h3>
      </div>

      <div className="page-content">
        {error && (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-circle me-1" />
            {error}
          </div>
        )}

        <div className="row">
          <div className="col-lg-8 col-lg-offset-3">
            <div className="header text-center">
              <div className="logo">
                <img
                  style={{ height: 120 }}
                  className="col-lg-3 bg-gray rounded"
                  src="/icon.svg"
                  alt="Logo"
                />
              </div>
            </div>

            <div className="content">
              <div className="form-group">
                <BasicInput label="Username" value={username} onChange={setUsername} disabled={loading} />
              </div>
              <div className="form-group">
                <BasicInput label="Email" value={email} onChange={setEmail} disabled={loading} />
              </div>
              <div className="form-group">
                <BasicInput
                  label="Password Baru"
                  type="password"
                  value={password}
                  onChange={setPassword}
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <BasicInput label="Role" value={type} onChange={setType} disabled={loading} />
              </div>
              <div className="form-group">
                <BasicInput label="Tanggal Aktivasi" value={activation} disabled />
              </div>
              <div className="form-group">
                <BasicInput label="Creation" value={creation} disabled />
              </div>
              <div className="form-group">
                <BasicInput label="Modified" value={modified} disabled />
              </div>

              <button onClick={handleUpdate} type="button" className="btn btn-success" disabled={saving || loading}>
                {saving ? 'Updating...' : 'Update'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile
